import React from "react"

const ValueCard = ({ title, text, background, height = 310, className }) => {
  const style = {
    ["--card-bg"]: background || "",
    ["--card-h"]: `${height}px`,
  }

  return (
    <article
      className={`value-card has-text-purple ${className ?? ""}`}
      style={style}
    >
      <div className="value-card-content px-2">
        <h3 className="value-title has-text-weight-semibold has-text-purple has-line-height-2">
          {title}
        </h3>
        <p className="value-text has-text-purple has-text-weight-light mt-3 has-line-height-2">
          {text}
        </p>
      </div>
    </article>
  )
}

export default ValueCard
